import type { SvgProps } from "../types";

export const DanceSvg = ({
  width = "100px",
  height = width,
  color = "#000000",
}: SvgProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Dance</title>
      <path
        d="M262.512 79.0921C266.316 76.1025 282.907 70.6308 286.476 76.7454C298.079 96.6275 266.424 112.227 256.92 99.8192C246.044 85.6191 268.599 62.2871 283.68 72.8348"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M239.375 43C251.664 62.6281 243.809 85.5633 241.892 106.648"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M242.252 110.561C252.596 111.862 278.588 118.452 288.999 116.717"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M242.251 110.561C221.506 123.66 164.238 118.323 141.206 112.041C131.363 109.357 120.985 104.838 111 103.411"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M211.431 166.72C231.261 143.725 261.21 174.753 237.248 192.123C209.873 211.966 203.924 174.325 215.846 163.773"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M203.636 194.761C200.838 174.521 195.256 147.433 197.694 118.639"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M202.746 194.761C192.546 218.3 207.225 249.492 204.988 256.535C194.494 289.575 197.534 324.91 204.988 357.766"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M204.989 256.534C197.99 272.039 176.509 347.574 181.252 357.766"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
